﻿import React, { useState, useEffect } from 'react';
import { Card, CardContent, Typography, Grid, CardMedia } from '@mui/material';
import { GetPromoItemById, GetColors, GetSizes } from 'api/contentmanagement.js';
import { useQuery } from '@tanstack/react-query';
import PromoItemModal from './PromoItemModal';

export default function PromoItemCard({ item, addToCart }) {
  const promoItemQuery = useQuery({
    queryKey: ['GetPromoItemById', item.ID],
    queryFn: () => GetPromoItemById({ ID: item.ID })(),
    enabled: !!item.ID,
  });

  const [itemData, setItemData] = useState(null);

  const colorsQuery = useQuery({
    queryKey: ['GetColors'],
    queryFn: () => GetColors()(),
  });
  const [parsedColors, setParsedColors] = useState([]);

  const sizesQuery = useQuery({
    queryKey: ['GetSizes'],
    queryFn: () => GetSizes()(),
  });
  const [parsedSizes, setParsedSizes] = useState([]);

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (promoItemQuery.isSuccess && promoItemQuery.data && !itemData) {
      setItemData(promoItemQuery.data);
    }
  }, [promoItemQuery.isSuccess, promoItemQuery.data, itemData]);

  useEffect(() => {
    if (!colorsQuery.isPending && !colorsQuery.isError && colorsQuery.data) {
      const parsed = JSON.parse(colorsQuery.data);
      setParsedColors(parsed);
    }
  }, [colorsQuery.data, colorsQuery.isPending, colorsQuery.isError]);

  useEffect(() => {
    if (!sizesQuery.isPending && !sizesQuery.isError && sizesQuery.data) {
      const parsed = JSON.parse(sizesQuery.data);
      setParsedSizes(parsed);
    }
  }, [sizesQuery.data, sizesQuery.isPending, sizesQuery.isError]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  if (promoItemQuery.isLoading) {
    return <div>Loading...</div>;
  }

  if (promoItemQuery.isError) {
    return <div>Error: {promoItemQuery.error.message}</div>;
  }

  if (!itemData) {
    return null;
  }

  const availableColors = parsedColors.filter((color) => itemData.colorIDs.includes(color.ID));
  const availableSizes = parsedSizes.filter((size) => itemData.sizeIDs.includes(size.ID));

  return (
    <>
      <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }} onClick={handleOpen}>
        <CardMedia
          sx={{ height: 0, paddingTop: '56.25%' }}
          image={'/CmsImages/' + itemData.imageName}
          title={itemData.title}
          style={{ maxWidth: '100%', maxHeight: '100%', backgroundSize: 'contain' }}
        />
        <CardContent sx={{ flexGrow: 1 }}>
          <Typography variant="h5" component="h2">
            {itemData.title}
          </Typography>
          <Typography color="textSecondary">{itemData.itemDescription}</Typography>
          <Typography variant="body2" component="p">
            Price: ${parseFloat(itemData.pricePerUnit).toFixed(2)}
          </Typography>
        </CardContent>
      </Card>
      <PromoItemModal
        key={item.ID}
        open={open}
        handleClose={handleClose}
        item={item}
        itemData={itemData}
        availableColors={availableColors}
        availableSizes={availableSizes}
        addToCart={addToCart}
      />
    </>
  );
}
